const funnyFacts = [
  "Coffee is the world's second most traded commodity! ☕🌍",
  "Drinking coffee before studying may improve memory! 📚",
  "Espresso has less caffeine than you think! 😲",
  "Coffee can improve your mood instantly! 😄",
  "Decaf doesn’t mean caffeine-free! ⚡",
  "Coffee beans are actually seeds, not beans! 🌱",
  "Coffee was originally chewed, not brewed! 😮"
];

export default funnyFacts;